/**
 * The external dependencies.
 */
import {all, call, takeLatest} from 'redux-saga/effects';
/**
 * The internal dependencies.
 */
import request from '../../common/request';
import {
    getworkstepcount,
    resetCurrentTracking,
    setCurrentTracking,
    setTasksFormatted,
    setworkstepcount,
    tasksAcceptErrormessage,
    tasksAllWorkStepsReceive,
    tasksDeselect,
    tasksErrormessageAccepted,
    tasksPause,
    tasksReceive,
    tasksRecievedChildren,
    tasksRecievedErrormessage,
    tasksRecievedHandbook,
    tasksRecievedInstructions,
    tasksReportError,
    tasksRequest,
    tasksSelect,
    tasksSetSortingPagination,
    tasksStepsReceive,
    tasksStepsRequest,
    tasksUpdate,
    tasksWorkFinished,
    tasksWorkplacesReceive,
    tasksWorkplacesRequest,
    tasksWorkStarted,
    tasksWorkStepsReceive,
    tasksWorkStepsRequest,
    setCustomFilter
} from './actions';
import * as R from "ramda";
import store from "../index";
import {returnId} from "../../common/api";
import {getTaskColumnsAndTasks, getTaskCurrentTracking, getTasksFormattedItems} from "./selectors";

/**
 * Start a network request to fetch tasks.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerTasksRequest(action) {
    const sortingPaginationValue = R.clone(store.getState().tasks.sortingPaginationValue);
    /*setTimeout(
        function () {
            store.dispatch(resetLoading());
        }.bind(this),
        3000
    );*/
    yield call(request, {
        endpoint: 'getTasks',
        params: [sortingPaginationValue],
        requestAction: action,
        receiveAction: tasksReceive,
    });
}

export function* workerTasksReceive(action) {
    // const sortingPaginationValue = R.clone(store.getState().tasks.sortingPaginationValue);
//     console.log("workerTasksReceive", action, R.clone(store.getState()));
    store.dispatch(setTasksFormatted(getTaskColumnsAndTasks(store.getState())));

}

/**
 * Start a network request to fetch tasks steps.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerTasksStepsRequest(action) {
    yield call(request, {
        endpoint: 'getTasksWorkplaces',
        params: [],
        requestAction: action,
        receiveAction: tasksStepsReceive,
    });
}


/**
 * Start a network request to fetch tasks workplaces.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerTasksWorkplaceRequest(action) {
    yield call(request, {
        endpoint: 'getTasksWorkplaces',
        params: [],
        requestAction: action,
        receiveAction: tasksWorkplacesReceive,
    });
}


export function* workerTasksWorkStepsRequest(action) {
    yield call(request, {
        endpoint: 'getTasksWorkSteps',
        params: [],
        requestAction: action,
        receiveAction: tasksWorkStepsReceive,
    });
}

export function* workerTasksAllWorkStepsRequest(action) {
    yield call(request, {
        endpoint: 'getAllTasksWorkSteps',
        params: [],
        requestAction: action,
        receiveAction: tasksAllWorkStepsReceive,
    });
}

export function* workerTaskSelect(action) {
    const task = action.payload.task;
    const myorders = R.clone(store.getState().tasks.orders);
    const orderIndex = R.findIndex(R.propEq('id', task.order_id))(myorders);
    const order = myorders[orderIndex];

    yield call(request, {
        endpoint: 'getWarnings',
        params: [task, order],
        requestAction: action,
        receiveAction: tasksRecievedErrormessage,
    });
}

export function* workerGetChildren(action) {
    const task = action.payload.task;
    yield call(request, {
        endpoint: 'getTaskChildren',
        params: [task],
        requestAction: action,
        receiveAction: tasksRecievedChildren,
    });
}

export function* workerGetInstructions(action) {
    const task = action.payload.task;
    yield call(request, {
        endpoint: 'getTasksSteps',
        params: [{
            client: task.order_client,
            erpnumber: task.erpnumber
        }],
        requestAction: action,
        receiveAction: tasksRecievedInstructions,
    });
}

export function* workerGetHandbook(action) {
    const task = action.payload.task;
    yield call(request, {
        endpoint: 'getTasksHandbook',
        params: [{
            client: task.order_client,
            erpnumber: task.erpnumber
        }],
        requestAction: action,
        receiveAction: tasksRecievedHandbook,
    });
}

export function* workerTaskDeselect(action) {
    yield null;
}

export function* workerTasksUpdate(action) {
    const mytasks = R.clone(store.getState().tasks.items);
    const index = R.findIndex(R.propEq('id', action.payload.id))(mytasks);
    const task = mytasks[index];
    if (action.payload.data !== undefined && action.payload.data.enabled === true) {
        yield null;
    } else {
        yield call(request, {
            endpoint: 'updateTask',
            params: [{task: task, update: action.payload.data}],
            requestAction: action,
            receiveAction: tasksRequest,
        });
    }
}

export function* workerTasksPause(action) {
    const mytasks = R.clone(store.getState().tasks.items);
    const index = R.findIndex(R.propEq('id', action.payload.id))(mytasks);
    const task = mytasks[index];
    if (action.payload.data !== undefined && action.payload.data.enabled === true) {
        yield null;
    } else {
        yield call(request, {
            endpoint: 'pauseTask',
            params: [{task: task, update: action.payload.data}],
            requestAction: action,
            receiveAction: tasksRequest,
        });
    }
}

export function* workerTasksReportError(action) {

    const {step, quantity, message, scrap} = action.payload.data;

    const mytasks = R.clone(store.getState().tasks.items);
    const index = R.findIndex(R.propEq('id', action.payload.id))(mytasks);
    const task = mytasks[index];
    const myorders = R.clone(store.getState().tasks.orders);
    const orderIndex = R.findIndex(R.propEq('id', task.order_id))(myorders);
    const order = myorders[orderIndex];

    let data = {
        client: order.client,
        erpnumber: task.erpnumber,
        content: message,
        task_id: returnId(task._links.self.href),
        order_id: task.order_id,
        user_id: '',
        errorreport_id: '',
        quantity: task.quantity,
        place: task.place,
        step: task.step,
        worker: '',
        priority: task.priority,
        status: task.status,
        scrap: scrap,
        error_step: step.selectionorder,
        error_quantity: quantity,
        error_message: message
    };

    yield call(request, {
        endpoint: 'submitErrorReport',
        params: [data, action.payload.data.photos],
        requestAction: action,
        receiveAction: tasksRecievedErrormessage,
    });
}

export function* workerTasksWorkStarted(action) {


    if (R.isEmpty(getTaskCurrentTracking(store.getState()))) {
        const {task} = action.payload;
        const orders = R.clone(store.getState().tasks.orders);
        const order = orders[R.findIndex(R.propEq('id', task.order_id))(orders)];

        let data = {
            client: order.client,
            erpnumber: task.erpnumber,
            task_id: returnId(task._links.self.href),
            order_id: task.order_id,
            user_id: '',
            quantity: task.quantity,
            place: task.place,
            step: task.step,
            worker: '',
            priority: task.priority,
            status: task.status,
        };

        yield call(request, {
            endpoint: 'startTracking',
            params: [data],
            requestAction: action,
            receiveAction: setCurrentTracking,
        });
    } else {

    }
}

export function* workerTasksWorkFinished(action) {
    let uuid = getTaskCurrentTracking(store.getState()).uuid;
    if (uuid !== undefined) {
        yield call(request, {
            endpoint: 'closeTracking',
            params: [uuid],
            requestAction: action,
            receiveAction: resetCurrentTracking,
        });
    }
}

export function* workerTasksAcceptErrormessage(action) {

    const {task} = action.payload;
    const orders = R.clone(store.getState().tasks.orders);
    const order = orders[R.findIndex(R.propEq('id', task.order_id))(orders)];

    let data = {
        client: order.client,
        erpnumber: task.erpnumber,
        task_id: returnId(task._links.self.href),
        user_id: '',
        worker: '',
        quantity: task.quantity,
        place: task.place,
        step: task.step,
    };
    yield call(request, {
        endpoint: 'acceptError',
        params: [data],
        requestAction: action,
        receiveAction: tasksErrormessageAccepted,
    });

}

export function* workergetworkstepcount(action) {

    yield call(request, {
        endpoint: 'getworkstepcount',
        params: [],
        requestAction: action,
        receiveAction: setworkstepcount,
    });

}

/**
 * Coordinate the workers.
 *
 * @return {Generator}
 */
export default function* ContentForeman() {
    yield all([
        takeLatest(tasksRequest, workerTasksRequest),
        takeLatest(tasksReceive, workerTasksReceive),
        takeLatest(setCustomFilter, workerTasksReceive),
        takeLatest(tasksSetSortingPagination, workerTasksRequest),
        takeLatest(tasksStepsRequest, workerTasksStepsRequest),
        takeLatest(tasksWorkplacesRequest, workerTasksWorkplaceRequest),
        takeLatest(tasksWorkStepsRequest, workerTasksWorkStepsRequest),
        takeLatest(tasksWorkStepsRequest, workerTasksAllWorkStepsRequest),
        takeLatest(tasksSelect, workerTaskSelect),
        takeLatest(tasksSelect, workerGetChildren),
        takeLatest(tasksSelect, workerGetInstructions),
        takeLatest(tasksSelect, workerGetHandbook),
        takeLatest(tasksDeselect, workerTaskDeselect),
        takeLatest(tasksUpdate, workerTasksUpdate),
        takeLatest(tasksPause, workerTasksPause),
        takeLatest(tasksReportError, workerTasksReportError),
        takeLatest(tasksWorkStarted, workerTasksWorkStarted),
        takeLatest(tasksWorkFinished, workerTasksWorkFinished),
        takeLatest(tasksAcceptErrormessage, workerTasksAcceptErrormessage),
        takeLatest(getworkstepcount, workergetworkstepcount),
    ]);
}




// WEBPACK FOOTER //
// ./src/store/tasks/effects.js